import React from "react";
import { Form, Input, Radio } from "antd";
import SUpload from "../../../../components/S3Upload";

const InstallPackageSection = ({ form, softForm }) => {
  return (
    <>
      <Form.Item
        name="upload_type"
        label="提交方式"
        htmlFor={undefined}
        rules={[{ required: true, message: "请选择提交方式" }]}
        initialValue={0}
      >
        <Radio.Group>
          <Radio value={0}>安装包 URL 链接</Radio>
          <Radio value={1}>上传文件</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item dependencies={["upload_type"]}>
        {({ getFieldValue }) => {
          const type = getFieldValue("upload_type");
          if (type === 0 || type === "0") {
            return (
              <Form.Item
                colon={false}
                labelCol={{ style: { width: "150px" } }}
                label=" "
                name="soft_download_url"
                rules={[
                  { required: true, message: "请输入下载链接" },
                  {
                    message: "请输入 https 地址，文件名后缀 exe、msi 或 zip",
                    pattern: /^(https):\/\/.*\.(exe|zip|msi)$/,
                  },
                ]}
              >
                <Input placeholder="https://example.com/app.exe" />
              </Form.Item>
            );
          }

          return (
            <Form.Item
              colon={false}
              labelCol={{ style: { width: "150px" } }}
              label=" "
              name="real_file_name"
              htmlFor={undefined}
              valuePropName="fileList"
              rules={[{ required: true, message: "请上传安装包文件" }]}
            >
              <SUpload
                accept=".zip, .mis, .exe"
                tips="安装包不能超过512M，提交格式为zip，msi，exe"
                maxCount={1}
                name="real_file_name"
                form={form}
                softForm={softForm}
              />
            </Form.Item>
          );
        }}
      </Form.Item>
    </>
  );
};

export default InstallPackageSection;
